import React, { useRef } from 'react';
import Main from '../content/main';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch, FixType, QueryRequest, store } from '../../utils/types';
import QueryArea from '../common-components/QueryArea';
import {
  makeQuery,
  updateCurrentQueryDetiails,
  updateLastQueryString,
} from '../../actions/query';
import QueryResultArea from '../common-components/QueryResultArea';
import Accordion from '../common-components/Accordion';
import useDebounce from '../../hooks/use-debounce';

function MainPage({
  makeQueryAction,
  categoryStructure,
  setValues,
  doQueryStatus,
  requestedQueryDetails,
  updateLastQuery,
}: any) {
  const queryStrings = useLocation();
  const graphWrapperRef = useRef<any>(null);

  const debouncedQueryString = useDebounce(queryStrings.search, 200);

  useEffect(() => {
    const params = new URLSearchParams(debouncedQueryString);

    let values: FixType = {
      networkType: params.get('networkType'),
      networkName: params.get('networkName'),
      cohortDiseaseName: params.get('cohortDiseaseName'),
      locations: params.get('locations')?.split('|,'),
      search: params.get('search')?.split('|,'),
      nodeLimit: Number(params.get('nodeLimit')),
      pruning: Number(params.get('pruning')),
      includeNeighbourConnections:
        params.get('includeNeighbourConnections') === 'true',
      clustering: true, // TODO params.get('clustering') === 'true'
      visualize: params.get('visualize') === 'true',
      correlation: params.get('correlation') || 'both',
    };

    try {
      const { id } =
        categoryStructure[values.networkType][values.networkName][
          values.cohortDiseaseName
        ];

      values = {
        ...values,
        categoryId: id,
      };
    } catch {}
    if (values.cohortDiseaseName && values.search) {
      makeQueryAction(values);
      setValues(values);
      updateLastQuery(debouncedQueryString.substring(1));
    }
  }, [
    debouncedQueryString,
    makeQueryAction,
    setValues,
    categoryStructure,
    updateLastQuery,
  ]);

  return (
    <div className="w-full flex">
      {!requestedQueryDetails && (
        <div className="flex-1 flex h-full">
          <div className="hidden w-2/3 md:block overflow-auto">
            <Main />
          </div>
          <div className="w-full md:w-1/3 bg-white overflow-auto">
            <div className="h-full w-full px-8 max-w-lg mx-auto">
              <div className="pt-14 mb-11 text-5xl font-thin lg:text-6xl ">
                <span>Search</span>
              </div>
              <QueryArea />
            </div>
          </div>
        </div>
      )}

      {requestedQueryDetails && (
        <div className="flex-1 justify-end md:flex-row w-full h-full relative">
          <div className="flex w-full overflow-hidden z-40">
            <QueryResultArea graphWrapperRef={graphWrapperRef} />
          </div>
          <div className="absolute z-50">
            <Accordion graphWrapperRef={graphWrapperRef} />
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state: store) => ({
  doQueryStatus: state.query.doQueryOp.status,
  requestedQueryDetails: state.query.requestedQueryDetails,
  categoryStructure: state.dataTypes.catStructure,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  makeQueryAction: (queryRequest: QueryRequest) =>
    dispatch(makeQuery(queryRequest)),
  setValues: (currentQueryDetails: QueryRequest) =>
    dispatch(updateCurrentQueryDetiails(currentQueryDetails)),
  updateLastQuery: (queryString: string) =>
    dispatch(updateLastQueryString(queryString)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
